<div class="page">
  @if (!isServer) {
    @if (os === 'ios') {
      <div class="mobile">
        <img [src]="gallery() | galleryTeaserUrl: 132" class="teaser" alt="" />
        <h1>{{ gallery().title }}</h1>
      </div>

      <div class="bottom-content">
        <img src="/assets/icons/special/ios-share.svg" class="ios-share" alt="" />
        <p>To install the app, tap the <b>Share Icon</b> and choose <b>Add to Home Screen</b>.</p>
      </div>
    } @else if (os === 'android') {
      <div class="mobile">
        <img [src]="gallery() | galleryTeaserUrl: 132" class="teaser" alt="" />
        <h1>{{ gallery().title }}</h1>

        @if (installPrompt()) {
          <button
            appButton
            name="install"
            location="gallery-pwa-page"
            shape="round"
            (click)="installPrompt().prompt()"
            [center]="true"
            weight="bold"
            spacing="3"
          >
            Install App
          </button>
        }
      </div>

      @if (!installPrompt()) {
        <div class="bottom-content">
          <img src="/assets/icons/special/android-share.svg" class="android-share" alt="" />
          <p>To install the app, tap the <b>Menu Icon</b> and choose <b>Add to Home Screen</b>.</p>
        </div>
      }
    } @else {
      <div class="desktop">
        <img src="/assets/icons/special/app-bg.svg" class="bg" alt="" />
        <img [src]="gallery() | galleryTeaserUrl: 132" class="teaser" alt="" />
        <h1>{{ gallery().title }}</h1>

        <app-svg src="/assets/icons/mobile-phone.svg"></app-svg>
        <p>Open this page on your mobile phone or tablet to install the app.</p>
      </div>
    }
  } @else {
    <app-loading-indicator></app-loading-indicator>
  }
</div>
